import React, { useState } from 'react';
import ArrangementOrganizationSelector from '../shared/arrangement_organization_selector';

const getDefaultOrganizationIds = (): number[] => {
  const organizationIds = utils.getParam('organization_ids');
  if (!organizationIds) {
    return [];
  }
  return organizationIds.split(',').map((id: string) => parseInt(id, 10));
};

type UseOrganizationSelectorReturn = [number[], () => JSX.Element, ((ids: number[]) => void)?];

// restoreFromUrl: 他タブが書き出したURLパラメータを復元したくないタブは false を渡す
const useOrganizationSelector = (restoreFromUrl = true): UseOrganizationSelectorReturn => {
  const [organizationIds, setOrganizationIds] = useState<number[]>(
    restoreFromUrl ? getDefaultOrganizationIds() : []
  );

  const renderOrganizationSelector = () => (
    <ArrangementOrganizationSelector
      selectedOrganizationIds={organizationIds}
      onSelect={ids => setOrganizationIds(ids)}
    />
  );

  return [organizationIds, renderOrganizationSelector, setOrganizationIds];
};

export default useOrganizationSelector;
